import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { PDP_CUSTOMIZE_TAB_ID, PDP_DECIDELATER_TAB_ID } from 'commons/constants';
import CtaButton from 'components/essentials/Cta/CtaButton';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import useProductEFGInternalStatus from 'data-hooks/useProductEFGInternalStatus';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import { PRODUCT_CONFIGURATION_INTERACTION, trackProductConfigurationInteracted } from 'data-hooks/useEvents/pdpInteractionEvents';
import PDPSelectUpholsteryDecideLater from '../PDPSelectUpholstery/PDPSelectUpholsteryDecideLater';
import usePDPOptions from '../state/context/usePDPOptions';
import usePdpSelectedCustomizerTab from '../state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import useSetPdpSelectedCustomizerTab from '../state/pdpSelectedCustomizerTab/useSetPdpSelectedCustomizerTab';

// Decide Later leaves the tab bar in the layout revamp; mirrors the conditions
// PDPShopTabsBar applies to the tab item it replaces
const PDPDecideLaterButtonInner = t0 => {
  const $ = _c(14);
  const {
    className: t1,
    isEditOrder: t2
  } = t0;
  const className = t1 === undefined ? "mt-4" : t1;
  const isEditOrder = t2 === undefined ? false : t2;
  const {
    data: t3
  } = usePDPOptions();
  const {
    upholsteryOptionId
  } = t3 === undefined ? {} : t3;
  const {
    isEFGInternal
  } = useProductEFGInternalStatus();
  const {
    data: basicDetails
  } = usePDPBasicDetails();
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  const setPdpSelectedCustomizerTab = useSetPdpSelectedCustomizerTab();
  if (isEditOrder || isEFGInternal || !upholsteryOptionId) {
    return null;
  }
  const isActive = pdpSelectedCustomizerTab === PDP_DECIDELATER_TAB_ID;
  const price = basicDetails?.meta?.price;
  const promoText = price?.max_discount_percent ? ` (lock in up to ${price.max_discount_percent}% off)` : price?.discount_percent ? ` (lock in ${price.discount_percent}% off)` : "";
  let t4;
  if ($[0] !== isActive || $[1] !== setPdpSelectedCustomizerTab) {
    t4 = () => {
      if (isActive) {
        setPdpSelectedCustomizerTab(PDP_CUSTOMIZE_TAB_ID);
        trackProductConfigurationInteracted(PRODUCT_CONFIGURATION_INTERACTION.DECIDE_LATER_CLOSED);
        return;
      }
      setPdpSelectedCustomizerTab(PDP_DECIDELATER_TAB_ID);
      trackProductConfigurationInteracted(PRODUCT_CONFIGURATION_INTERACTION.DECIDE_LATER_SELECTED);
    };
    $[0] = isActive;
    $[1] = setPdpSelectedCustomizerTab;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const toggleDecideLater = t4;
  const t5 = isActive ? "solid-button" : "outline-button";
  let t6;
  if ($[3] !== isActive || $[4] !== promoText || $[5] !== t5 || $[6] !== toggleDecideLater) {
    t6 = <CtaButton aria-pressed={isActive} className="focus:!shadow-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-brand" block={true} color="brand" spacing="sm" styling={t5} onClick={toggleDecideLater}>Decide Later{promoText}</CtaButton>;
    $[3] = isActive;
    $[4] = promoText;
    $[5] = t5;
    $[6] = toggleDecideLater;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== isActive) {
    t7 = isActive && <PDPSelectUpholsteryDecideLater className="mt-4" />;
    $[8] = isActive;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== className || $[11] !== t6 || $[12] !== t7) {
    t8 = <div className={className} data-xc="PDPDecideLaterButton">{t6}{t7}</div>;
    $[10] = className;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
};
PDPDecideLaterButtonInner.propTypes = {
  className: PropTypes.string,
  isEditOrder: PropTypes.bool
};
const PDPDecideLaterButton = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <SuspenseWithLoader><PDPDecideLaterButtonInner {...props} /></SuspenseWithLoader>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default PDPDecideLaterButton;